import { render, staticRenderFns } from "./DraftEmailIcon.vue?vue&type=template&id=40b81a9c&"
import script from "./DraftEmailIcon.vue?vue&type=script&lang=js&"
export * from "./DraftEmailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports